var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showInfoBox)?_c('InfoBox',{attrs:{"infoUri":_vm.infoUri||''}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }